import React from "react";
import { useTranslation } from "react-i18next";

import { BookedSlotProps } from "@models/components/user.model";

const BookedSlot: React.FC<BookedSlotProps> = ({
  endTime,
  showHeading = true,
  slotType,
  startTime,
}) => {
  const { t } = useTranslation();

  return (
    <div className="modal-para-section" data-testid="booked-slot">
      {showHeading && <h5>{t("bookedSlotTime")}</h5>}
      <div className="fg-unit-slot-select">
        <button className="btn fg-btn fg-btn-small fg-btn-with-badge active">
          {slotType && (
            <span className="fg-badge" data-testid="slot-type">
              {slotType}
            </span>
          )}
          <span>{startTime && endTime ? `${startTime} - ${endTime}` : ""}</span>
        </button>
      </div>
    </div>
  );
};

export default BookedSlot;
